import React from 'react';
import { Url } from '@wix/da-url';
import BiLink from '../../../biLogger/Components/BiLink';
import { BiEventType } from '../../../biLogger/constants';
import { ResourceType } from '../../../types/resource';
var CollectionLink = function (_a) {
    var collection = _a.collection, className = _a.className;
    return (React.createElement(BiLink, { className: className, href: Url.userGalleryLink({
            username: collection.owner.username,
            gallectionType: 'collection',
            folderId: collection.folderId,
            folderName: collection.name,
        }), biData: {
            evid: BiEventType.ITEM_CLICK,
            sectionname: 'collections',
            typeid: ResourceType.COLLECTION,
            itemid: collection.folderId,
        } }, collection.name));
};
CollectionLink.displayName = 'CollectionLink';
export default CollectionLink;
//# sourceMappingURL=CollectionLink.js.map